import { User } from '@/models/domain/User'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type UserSelected = User & {
  selected: boolean
}

interface UserStore {
  user: UserSelected | null
  token: any
  detached: boolean
  setUser(user): void
  setToken(token: string | undefined): void
  setDetached(detached: boolean): void
  setIsSelected(selected: boolean): void
}

type InitialStateStore = Pick<UserStore, 'user' | 'token' | 'detached'>

const initialState: InitialStateStore = {
  user: null,
  token: null,
  detached: false
}

export const useUserStore = create<UserStore>()(
  devtools(
    (set) => ({
      ...initialState,
      setUser(user) {
        set({ user: user ? { ...user, selected: false } : null })
      },
      setIsSelected(selected) {
        set((state) => ({ user: { ...state.user!, selected } }))
      },
      setToken(token) {
        set({ token })
      },
      setDetached(detached) {
        set({ detached })
      }
    }),
    { name: 'useUserStore' }
  )
)
